import { useState } from 'react';
import { currentKeyPlatform, type KeyPlatform } from './platformKeys';

/**
 * System des Nutzers für die Beschriftung von Tastenkürzeln (⌘ oder Strg).
 * Einmal je Komponente ermittelt — das Betriebssystem wechselt nicht, während
 * die Seite offen ist. Beschriften mit `keyLabel`/`formatShortcut`.
 */
export function useKeyPlatform(): KeyPlatform {
  const [platform] = useState(currentKeyPlatform);
  return platform;
}
